(function () {
  'use strict';

  const CFG = window.BPConfig || {
    bundleQty: 6,
    bundleVariantId: null,
    bundlePriceFormatted: '£95.00',
    currency: '£',
    checkoutUrl: '/checkout',
  };

  let selected = [];

  const countEl       = document.getElementById('bp-count');
  const progressEl    = document.getElementById('bp-progress-fill');
  const checkoutBtn   = document.getElementById('bp-checkout-btn');
  const slotsContainer= document.getElementById('bp-slots');
  const productsGrid  = document.getElementById('bp-products-grid');
  const modal         = document.getElementById('bp-modal');
  const modalClose    = document.getElementById('bp-modal-close');
  const modalImg      = document.getElementById('bp-modal-img');
  const modalTitle    = document.getElementById('bp-modal-title');
  const modalPrice    = document.getElementById('bp-modal-price');
  const modalAddBtn   = document.getElementById('bp-modal-add');

  function init() {
    bindFilterTabs();
    bindProductCards();
    bindCheckout();
    bindModal();
    startCountdown();
    updateStickyBar();
  }

  function updateStickyBar() {
    const qty = CFG.bundleQty;
    const count = selected.length;
    const pct = (count / qty) * 100;
    if (countEl) countEl.textContent = count;
    if (progressEl) progressEl.style.width = pct + '%';
    if (checkoutBtn) {
      if (count >= qty) {
        checkoutBtn.classList.add('ready');
        checkoutBtn.disabled = false;
      } else {
        checkoutBtn.classList.remove('ready');
        checkoutBtn.disabled = true;
      }
    }
    renderSlots();
  }

  function renderSlots() {
    if (!slotsContainer) return;
    const slots = slotsContainer.querySelectorAll('.bp-slot');
    slots.forEach((slot, i) => {
      const item = selected[i];
      slot.innerHTML = '';
      if (item) {
        slot.classList.add('filled');
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title;
        slot.appendChild(img);
        const removeBtn = document.createElement('button');
        removeBtn.className = 'bp-slot-remove';
        removeBtn.textContent = '✕';
        removeBtn.setAttribute('aria-label', 'Remove ' + item.title);
        removeBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          removeItem(item.productId);
        });
        slot.appendChild(removeBtn);
      } else {
        slot.classList.remove('filled');
        const empty = document.createElement('div');
        empty.className = 'bp-slot-empty';
        slot.appendChild(empty);
      }
    });
  }

  function addItem(productId) {
    if (selected.length >= CFG.bundleQty) {
      showToast('Bundle complete! Remove a piece to swap it.');
      return;
    }
    if (selected.find(i => i.productId === productId)) {
      showToast('This piece is already in your bundle.');
      return;
    }
    const card = productsGrid.querySelector('[data-product-id="' + productId + '"]');
    if (!card) return;
    const item = {
      productId: productId,
      variantId: card.dataset.variantId,
      title: card.dataset.title,
      image: card.dataset.image,
    };
    selected.push(item);
    updateCardState(productId, true);
    updateStickyBar();
    celebrateIfFull();
  }

  function removeItem(productId) {
    selected = selected.filter(i => i.productId !== productId);
    updateCardState(productId, false);
    updateStickyBar();
    if (modal && modal.dataset.currentProductId === productId) closeModal();
  }

  function updateCardState(productId, isAdded) {
    const card = productsGrid.querySelector('[data-product-id="' + productId + '"]');
    if (!card) return;
    const addBtn = card.querySelector('.bp-add-btn');
    if (!addBtn) return;
    if (isAdded) {
      card.classList.add('in-bundle');
      addBtn.classList.add('included');
      addBtn.textContent = 'Included ✓';
    } else {
      card.classList.remove('in-bundle');
      addBtn.classList.remove('included');
      addBtn.textContent = 'Add';
    }
  }

  function celebrateIfFull() {
    if (selected.length === CFG.bundleQty) {
      showToast('🎉 Bundle complete! Click CHECKOUT to finish.');
      setTimeout(() => {
        checkoutBtn && checkoutBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 400);
    }
  }

  function bindProductCards() {
    if (!productsGrid) return;
    productsGrid.addEventListener('click', (e) => {
      const addBtn = e.target.closest('.bp-add-btn');
      const quickViewBtn = e.target.closest('.bp-quick-view-btn');
      if (addBtn) {
        const card = addBtn.closest('.bp-product-card');
        if (!card) return;
        const productId = card.dataset.productId;
        if (selected.find(i => i.productId === productId)) {
          removeItem(productId);
        } else {
          addItem(productId);
        }
      }
      if (quickViewBtn) {
        const card = quickViewBtn.closest('.bp-product-card');
        if (!card) return;
        openModal(card);
      }
    });
  }

  function bindFilterTabs() {
    const filterTabs = document.getElementById('bp-filter-tabs');
    if (filterTabs) {
      filterTabs.addEventListener('click', (e) => {
        const tab = e.target.closest('.bp-tab');
        if (!tab) return;
        filterTabs.querySelectorAll('.bp-tab').forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        filterProducts();
      });
    }
    const allGroups = document.querySelectorAll('.bp-filter-group');
    if (allGroups.length > 1) {
      const colorGroup = allGroups[1];
      colorGroup.addEventListener('click', (e) => {
        const tab = e.target.closest('.bp-tab');
        if (!tab) return;
        colorGroup.querySelectorAll('.bp-tab').forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        filterProducts();
      });
    }
  }

  function filterProducts() {
    if (!productsGrid) return;
    const activeFilterTab = document.querySelector('#bp-filter-tabs .bp-tab.active');
    const activeFilter = activeFilterTab ? activeFilterTab.dataset.filter : 'all';
    const allGroups = document.querySelectorAll('.bp-filter-group');
    let activeColor = 'all';
    if (allGroups.length > 1) {
      const colorActive = allGroups[1].querySelector('.bp-tab.active');
      activeColor = colorActive ? colorActive.dataset.color : 'all';
    }
    productsGrid.querySelectorAll('.bp-product-card').forEach(card => {
      const type = (card.dataset.type || '').toLowerCase();
      const tags = (card.dataset.tags || '').toLowerCase();
      const typeMatch = activeFilter === 'all' || type.includes(activeFilter) || tags.includes(activeFilter);
      const colorMatch = activeColor === 'all' || tags.includes(activeColor);
      card.classList.toggle('hidden', !(typeMatch && colorMatch));
    });
  }

  function bindCheckout() {
    if (!checkoutBtn) return;
    checkoutBtn.addEventListener('click', async () => {
      if (selected.length < CFG.bundleQty) return;
      checkoutBtn.textContent = 'Processing...';
      checkoutBtn.disabled = true;
      try {
        const properties = {};
        selected.forEach((item, idx) => {
          properties['Piece ' + (idx + 1)] = item.title;
        });
        await fetch('/cart/clear.js', { method: 'POST' });
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: CFG.bundleVariantId, quantity: 1, properties: properties }]
          }),
        });
        if (!res.ok) throw new Error('Cart error');
        window.location.href = CFG.checkoutUrl;
      } catch (err) {
        console.error('Bundle checkout error:', err);
        checkoutBtn.textContent = 'CHECKOUT';
        checkoutBtn.disabled = false;
        showToast('Error processing. Please try again.');
      }
    });
  }

  function openModal(card) {
    if (!modal) return;
    const productId = card.dataset.productId;
    modal.dataset.currentProductId = productId;
    if (modalImg) { modalImg.src = card.dataset.image; modalImg.alt = card.dataset.title; }
    if (modalTitle) modalTitle.textContent = card.dataset.title;
    if (modalPrice) modalPrice.textContent = 'Included in the £95 bundle';
    const isIncluded = !!selected.find(i => i.productId === productId);
    if (modalAddBtn) {
      modalAddBtn.textContent = isIncluded ? 'Remove from Bundle' : 'Add to Bundle';
      modalAddBtn.dataset.productId = productId;
    }
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('open');
    document.body.style.overflow = '';
  }

  function bindModal() {
    if (!modal) return;
    modalClose && modalClose.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });
    if (modalAddBtn) {
      modalAddBtn.addEventListener('click', () => {
        const productId = modalAddBtn.dataset.productId;
        if (selected.find(i => i.productId === productId)) {
          removeItem(productId);
        } else {
          addItem(productId);
        }
        closeModal();
      });
    }
  }

  function startCountdown() {
    const el = document.getElementById('bp-countdown');
    if (!el) return;
    const storageKey = 'bp_countdown_expires';
    let expires = sessionStorage.getItem(storageKey);
    if (!expires) {
      expires = Date.now() + (8 * 3600 + 27 * 60) * 1000;
      sessionStorage.setItem(storageKey, expires);
    }
    function tick() {
      const remaining = Math.max(0, expires - Date.now());
      if (remaining === 0) { el.textContent = '00H 00M 00S'; return; }
      const h = Math.floor(remaining / 3600000);
      const m = Math.floor((remaining % 3600000) / 60000);
      const s = Math.floor((remaining % 60000) / 1000);
      el.textContent = String(h).padStart(2,'0') + 'H ' + String(m).padStart(2,'0') + 'M ' + String(s).padStart(2,'0') + 'S';
      setTimeout(tick, 1000);
    }
    tick();
  }

  window.bpScrollReviews = function(dir) {
    const grid = document.getElementById('bp-reviews-carousel');
    if (!grid) return;
    const card = grid.querySelector('.bp-review-card');
    const cardW = card ? card.offsetWidth + 20 : 300;
    grid.scrollBy({ left: dir * cardW * 3, behavior: 'smooth' });
  };

  function showToast(msg) {
    let toast = document.getElementById('bp-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'bp-toast';
      Object.assign(toast.style, {
        position: 'fixed', bottom: '90px', left: '50%',
        transform: 'translateX(-50%)', background: '#111', color: '#fff',
        padding: '12px 24px', borderRadius: '6px', fontSize: '13px',
        fontFamily: "'Jost', sans-serif", zIndex: '999',
        pointerEvents: 'none', opacity: '0',
        transition: 'opacity 0.25s ease', maxWidth: '90vw', textAlign: 'center',
      });
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.style.opacity = '1';
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(() => { toast.style.opacity = '0'; }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();